import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import {
  UserGuidesInterface,
  UserInterface,
  UserMetaInterface,
  UserProfileInterface,
  UserSettingsInterface,
} from '@interface/user/user.interface';
import { portalQueryAuth } from '@util/api/portal-query-auth';

export const userApi = createApi({
  reducerPath: 'user-api',
  tagTypes: [TagTypesEnum.User, TagTypesEnum.UserMeta, TagTypesEnum.UserProfile, TagTypesEnum.UserSettings],
  baseQuery: portalQueryAuth('/users'),
  endpoints: (build) => ({
    loadMe: build.query<ResponseDataInterface<UserInterface>, undefined>({
      query: () => `/me`,
      providesTags: [TagTypesEnum.UserProfile],
    }),
    loadMeta: build.query<ResponseDataInterface<UserMetaInterface>, undefined>({
      query: () => `/meta`,
      providesTags: [TagTypesEnum.UserMeta],
    }),
    saveMeta: build.mutation<ResponseDataInterface<UserMetaInterface>, UserMetaInterface>({
      query: (credentials) => ({
        method: 'PUT',
        url: `/meta`,
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.UserMeta],
    }),
    loadProfile: build.query<ResponseDataInterface<UserProfileInterface>, undefined>({
      query: () => `/profile`,
      providesTags: [TagTypesEnum.UserProfile],
    }),
    saveProfile: build.mutation<ResponseDataInterface<UserProfileInterface>, UserProfileInterface>({
      query: (credentials) => ({
        method: 'PUT',
        url: `/profile`,
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.UserProfile],
    }),
    loadSettings: build.query<ResponseDataInterface<UserSettingsInterface>, undefined>({
      query: () => `/settings`,
      providesTags: [TagTypesEnum.UserSettings],
    }),
    saveSettings: build.mutation<ResponseDataInterface<UserSettingsInterface>, Partial<UserSettingsInterface>>({
      query: (credentials) => ({
        method: 'PUT',
        url: `/settings`,
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.UserSettings],
    }),
    saveGuides: build.mutation<ResponseDataInterface<UserGuidesInterface>, Partial<UserGuidesInterface>>({
      query: (credentials) => ({
        method: 'PUT',
        url: `/guides`,
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.UserSettings],
    }),
    loadMfa: build.query<ResponseDataInterface<boolean>, undefined>({
      query: () => `/mfa`,
    }),
  }),
});
